import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { accountMenuPaperSx } from './accountMenuPaperSx'
import { ACCOUNT_MENU_LIST_ID } from './primaryNavConstants'

function PrimaryNavAccountMenu({
  accountMenuOpen,
  accountMenuAnchor,
  accountMenuHeader,
  accountMenuItems,
  onClose,
  onItemSelect,
}) {
  return (
    <FloatingMenuPopup
      open={accountMenuOpen}
      anchorEl={accountMenuAnchor}
      onClose={onClose}
      header={accountMenuHeader}
      items={accountMenuItems}
      onItemSelect={onItemSelect}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      paperSx={accountMenuPaperSx(accountMenuAnchor)}
      menuListId={ACCOUNT_MENU_LIST_ID}
      menuListAriaLabel="Account"
    />
  )
}

export default PrimaryNavAccountMenu
